import { render, staticRenderFns } from "./vehicle-check-cfg.vue?vue&type=template&id=4e6fdee8&scoped=true&"
import script from "./vehicle-check-cfg.vue?vue&type=script&lang=js&"
export * from "./vehicle-check-cfg.vue?vue&type=script&lang=js&"
import style0 from "./vehicle-check-cfg.vue?vue&type=style&index=0&id=4e6fdee8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6fdee8",
  null
  
)

export default component.exports